import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_order_total_picked_units_by_orderIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderIds?: number[] }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, TotalOrderPrice?: number, ShipmentLine?: { OrderId?: number } }[] }> 
  {
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_order_total_picked_units_by_orderIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, TotalOrderPrice?: number, ShipmentLine?: { OrderId?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_order_total_picked_units_by_orderIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderIds?: number[], $keys: any[] }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, TotalOrderPrice?: number, ShipmentLine?: { OrderId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_order_total_picked_units_by_orderIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderIds?: number[]    }) {
      return false;
    }
}
